import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 3 }
const _hoisted_3 = { key: 5 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = ["alt", "src"]
const _hoisted_16 = { key: 6 }


export default /*@__PURE__*/_defineComponent({
  __name: 'contentWithImage',
  props: {
    outH1: { default: undefined },
    outH1Center: { type: Boolean, default: false },
    outH2: {},
    outH2Center: { type: Boolean, default: false },
    h1title: {},
    h2Title: {},
    useLiP: { type: Boolean, default: false },
    outPList: {},
    outP: { default: undefined },
    outPCenter: { type: Boolean, default: false },
    pList: {},
    liList: { default: undefined },
    useLi: { type: Boolean, default: false },
    lineHheight: { default: 1.7 },
    contentSpan: { default: 12 },
    imageSpan: { default: 12 },
    hasHr: { type: Boolean, default: false },
    hasTailHr: { type: Boolean, default: false },
    pFontSize: {},
    fontSize: {},
    fontWeight: {},
    titleColor: {},
    h2pList: {},
    imageList: {}
  },
  setup(__props: any) {


//定义props
const props = __props

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.outH1)
      ? (_openBlock(), _createElementBlock("h1", {
          key: 0,
          style: _normalizeStyle({ 'text-align': _ctx.outH1Center ? 'center' : 'left' })
        }, _toDisplayString(_ctx.outH1), 5))
      : _createCommentVNode("", true),
    (_ctx.hasHr)
      ? (_openBlock(), _createElementBlock("hr", _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.outH2)
      ? (_openBlock(), _createElementBlock("h2", {
          key: 2,
          style: _normalizeStyle({ 'text-align': _ctx.outH2Center ? 'center' : 'left' })
        }, _toDisplayString(_ctx.outH2), 5))
      : _createCommentVNode("", true),
    (_ctx.hasHr)
      ? (_openBlock(), _createElementBlock("hr", _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.outPList && _ctx.outPList.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          style: _normalizeStyle({ 'text-align': _ctx.outPCenter ? 'center' : 'left' })
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.outPList, (p, index) => {
            return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(p), 1))
          }), 128))
        ], 4))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.outP)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                style: _normalizeStyle({ 'text-align': _ctx.outPCenter ? 'center' : 'left', 'font-size': _ctx.pFontSize })
              }, _toDisplayString(_ctx.outP), 5))
            : _createCommentVNode("", true)
        ])),
    _createVNode(_component_el_row, {
      class: "textwithImage",
      gutter: 30
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 24,
          lg: _ctx.contentSpan,
          xl: _ctx.contentSpan,
          style: _normalizeStyle({ 'line-height': _ctx.lineHheight })
        }, {
          default: _withCtx(() => [
            (_ctx.h1title != undefined)
              ? (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(_ctx.h1title), 1))
              : _createCommentVNode("", true),
            (_ctx.h2pList && _ctx.h2pList.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.h2pList, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      (item.h2 != undefined)
                        ? (_openBlock(), _createElementBlock("h2", _hoisted_6, _toDisplayString(item.h2), 1))
                        : _createCommentVNode("", true),
                      (item.h3 != undefined)
                        ? (_openBlock(), _createElementBlock("h3", {
                            key: 1,
                            style: _normalizeStyle({ 'color': item.h3Color })
                          }, _toDisplayString(item.h3), 5))
                        : _createCommentVNode("", true),
                      (item.pList && item.pList.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            (item.pStrong)
                              ? (_openBlock(), _createElementBlock("strong", _hoisted_8, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.pList, (p, index) => {
                                    return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(p), 1))
                                  }), 128))
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.pList, (p, index) => {
                                    return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(p), 1))
                                  }), 128))
                                ]))
                          ]))
                        : _createCommentVNode("", true),
                      (item.liList != undefined && item.liList.length > 0)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.liList, (li, index) => {
                              return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(li), 1))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (_ctx.h2Title != undefined)
                    ? (_openBlock(), _createElementBlock("h2", {
                        key: 0,
                        style: _normalizeStyle({ 'font-size': _ctx.fontSize, 'font-weight': _ctx.fontWeight, 'color': _ctx.titleColor })
                      }, _toDisplayString(_ctx.h2Title), 5))
                    : _createCommentVNode("", true),
                  (_ctx.liList && _ctx.liList.length > 0 && _ctx.useLi)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.liList, (item, index) => {
                          return (_openBlock(), _createElementBlock("li", { key: index }, [
                            (_ctx.useLiP)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(item), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", null, _toDisplayString(item), 1)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pList, (p, index) => {
                          return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(p), 1))
                        }), 128))
                      ]))
                ])),
            _renderSlot(_ctx.$slots, "imageList", {}, undefined, true)
          ]),
          _: 3
        }, 8, ["lg", "xl", "style"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageList, (image, index) => {
          return (_openBlock(), _createBlock(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: _ctx.imageSpan,
            xl: _ctx.imageSpan,
            key: index
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                alt: image.alt,
                src: image.imgUrl
              }, null, 8, _hoisted_15)
            ]),
            _: 2
          }, 1032, ["lg", "xl"]))
        }), 128))
      ]),
      _: 3
    }),
    (_ctx.hasTailHr)
      ? (_openBlock(), _createElementBlock("hr", _hoisted_16))
      : _createCommentVNode("", true)
  ], 64))
}
}

})